var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.handleDownload}},[_vm._v("JSZip下载")])}
var staticRenderFns = []

export { render, staticRenderFns }